import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserDetail } from "../../Api/getUserDetail";

// Thunk action for getting a list of network locations

export const getUserDetails = createAsyncThunk(
  "getUserDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await getUserDetail(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
